"use client";

import { AiSidePanelContent } from "./ai-side-panel-provider";
import { MemoSidePanel } from "./memo-side-panel";
import { useWorkspaceSidePanelMode } from "./workspace-side-panel-mode";

/**
 * workspace の右 side panel に表示する surface を mode で切り替えます。
 * AI chat の状態は保持したまま、User memo だけを別 surface として排他的に表示します。
 */
export function WorkspaceSidePanelContent() {
  const { mode } = useWorkspaceSidePanelMode();

  if (mode === "MEMO") {
    return <MemoSidePanel />;
  }

  return <AiSidePanelContent />;
}
